import { createContext, use } from "react";
import type { AbsencesCalendarController } from "./use-absences-calendar";

/** Interface */
interface IAbsencesCalendarContext {
	controller: AbsencesCalendarController;
}

export const AbsencesCalendarContext = createContext<IAbsencesCalendarContext>(
	{} as IAbsencesCalendarContext,
);

export function useAbsencesCalendarContext() {
	return use(AbsencesCalendarContext);
}
